import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Dayjs } from "dayjs";

interface CustomTimePickerProps {
  label: string;
  value: Dayjs | null; // Add value prop to accept the time from parent
  onTimeChange: (newTime: Dayjs | null) => void; // Add onTimeChange prop
  error?: boolean;
}

const CustomTimePicker = React.forwardRef<
  HTMLInputElement,
  CustomTimePickerProps
>(({ label, value, onTimeChange, error = false }, ref) => {
  const [selectedTime, setSelectedTime] = React.useState<Dayjs | null>(value);

  React.useEffect(() => {
    setSelectedTime(value);
  }, [value]);

  const handleTimeChange = (newValue: Dayjs | null) => {
    setSelectedTime(newValue);
    onTimeChange(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* <DemoContainer components={["TimePicker"]} sx={{ padding: 0, minWidth: "0px important" }}> */}
        <TimePicker
          label={label}
          value={selectedTime}
          onChange={handleTimeChange}
          slotProps={{
            textField: {
              size: "small",
              inputRef: ref,
              error: error,
              fullWidth: true,
              sx: {
                minWidth: "0px important",
                "& .MuiOutlinedInput-root": {
                  borderColor: error ? "red" : undefined,
                  "&.Mui-focused fieldset": {
                    borderColor: error ? "red" : undefined,
                  },
                },
              },
            },
          }}
          openTo="hours"
          views={["hours", "minutes"]}
          ampm={true}
          disableOpenPicker={false}
        />
      {/* </DemoContainer> */}
    </LocalizationProvider>
  );
});

export default CustomTimePicker;
